<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-sms-titles-body" :class="{ 'dw-sms-titles-body--empty': !items.length }">
            <template v-if="items.length">
                <div class="dw-sms-titles-tags">
                    <div v-for="(title, i) in items" :key="i" class="dw-sms-title-tag">
                        <span class="dw-sms-title-dot" :style="{ background: accent(i) }"></span>
                        <span class="dw-sms-title-name">{{ titleName(title) }}</span>
                    </div>
                </div>
                <div class="dw-sms-titles-footer">
                    <span class="dw-sms-provider-badge">{{ providerName() }}</span>
                    <span class="dw-sms-titles-count">{{ $t('common.dashboard.widgetLabels.smsTitlesCount', { count: items.length }) }}</span>
                </div>
            </template>
            <div v-else class="dw-sms-titles-empty">
                <div class="dw-sms-titles-empty-icon"><i class="bi bi-chat-square-text"></i></div>
                <div class="dw-sms-titles-empty-text">{{ $t('common.dashboard.widgetEmpty.smsTitlesTitle') }}</div>
                <div class="dw-sms-titles-empty-sub">{{ $t('common.dashboard.widgetEmpty.smsTitlesSub', { provider: providerName() }) }}</div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { cssVar } from '../chartOpts';

export const meta = {
    id: 'sms_titles',
    titleKey: 'common.dashboard.widgetTitles.sms_titles',
    icon: 'bi-chat-square-text',
    accent: 'var(--bs-info)',
    accentBg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)',
    glassRgb: '114, 57, 234',
    defaultCol: 1,
    defaultRow: 1,
    multiInstance: true,
    source: { type: 'module', moduleCode: 'NETGSM', code: 'SENDER_LIST' },
    defaultConfig: { provider: 'NETGSM' },
    configFields: [
        { key: 'provider', label: 'common.dashboard.widgetFields.provider', type: 'sms_provider_select' },
    ],
};

export default {
    name: 'SmsTitlesWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        items() {
            return this.apiData?.items || [];
        },
    },
    methods: {
        titleName(t) {
            if (typeof t === 'string') return t;
            return t?.name || t?.sender || t?.title || t?.value || '';
        },
        accent(i) {
            const colors = [
                '#3B82F6',
                cssVar('--bs-success', '#50CD89'),
                cssVar('--bs-info', '#7239EA'),
                cssVar('--bs-warning', '#FFC700'),
                cssVar('--bs-danger', '#F1416C'),
                cssVar('--bs-gray-600', '#7E8299'),
            ];
            return colors[i % colors.length];
        },
    },
};
</script>

<style>
.dw-sms-titles-body--empty {
    align-items: center;
    justify-content: center;
}
.dw-sms-titles-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    padding: 8px 12px;
}
.dw-sms-titles-empty-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(var(--bs-info-rgb, 114, 57, 234), 0.10);
    color: var(--bs-info);
    margin-bottom: 4px;
}
.dw-sms-titles-empty-icon .bi { font-size: 26px; }
.dw-sms-titles-empty-text {
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-body-color);
}
.dw-sms-titles-empty-sub {
    font-size: 11px;
    color: var(--bs-gray-500);
    line-height: 1.4;
    max-width: 220px;
}
</style>
